var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownChevronWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03094 3.0508C8.24905 2.83723 8.60268 2.83723 8.82079 3.0508C9.0389 3.26437 9.0389 3.61063 8.82079 3.8242L5.6293 6.9492C5.41119 7.16277 5.05756 7.16277 4.83945 6.9492L1.64796 3.8242C1.42985 3.61063 1.42985 3.26437 1.64796 3.0508C1.86607 2.83723 2.2197 2.83723 2.43781 3.0508L5.2359 5.7906L8.03094 3.0508Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 8,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03094 3.0508C8.24905 2.83723 8.60268 2.83723 8.82079 3.0508C9.0389 3.26437 9.0389 3.61063 8.82079 3.8242L5.6293 6.9492C5.41119 7.16277 5.05756 7.16277 4.83945 6.9492L1.64796 3.8242C1.42985 3.61063 1.42985 3.26437 1.64796 3.0508C1.86607 2.83723 2.2197 2.83723 2.43781 3.0508L5.2359 5.7906L8.03094 3.0508Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownChevronWhite);
export default __webpack_public_path__ + "static/media/down-chevron-white.5d463e69bd3dcf10dd9f53c1c3bf2d46.svg";
export { ForwardRef as ReactComponent };